import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationContext = /*#__PURE__*/createContext();

// eslint-disable-next-line react/prop-types
const ValidationProvider = _ref => {
  let {
    rules = {},
    ...rest
  } = _ref;
  const [values, setValues] = useState(rules);
  const handleRules = value => {
    setValues(prev => ({
      ...prev,
      ...value
    }));
  };
  return /*#__PURE__*/_jsx(ValidationContext.Provider, {
    value: {
      rules: values,
      setRules: handleRules
    },
    ...rest
  });
};
const useValidation = validationRuleName => {
  const context = useContext(ValidationContext);
  if (context) {
    const {
      rules
    } = context;
    return rules[validationRuleName];
  }
  return null;
};
export { ValidationProvider, useValidation };